import PropTypes from 'prop-types';

export default PropTypes.shape({
  time: PropTypes.number.isRequired,
  systemId: PropTypes.string.isRequired,
  productId: PropTypes.string.isRequired,
  ipAddress: PropTypes.string.isRequired,
  declined: PropTypes.bool.isRequired,
  hexObjectId: PropTypes.string.isRequired
});


// WEBPACK FOOTER //
// ./src/shapes/pending-product-instance.js